import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks.ts';
import { getSidebarAsset, resetAssetSidebar } from './assetSidebarSlice.ts';
import { AssetDetails } from './AssetDetails.tsx';
import type { AssetWithDevices } from '../../AssetsHelpGang.tsx';
import { AssetStatus } from '../../../api/assetAdministrationBackendCodec.ts';
import { DeleteAsset } from './action/DeleteAsset.tsx';
import { ActivateAsset } from './action/ActivateAsset.tsx';
import { ArchiveAsset } from './action/ArchiveAsset.tsx';
import { AssociateDevice } from './action/AssociateDevice.tsx';

export const AssetSidebar = () => {
    const dispatch = useAppDispatch();

    const assetWithDevices = useAppSelector(getSidebarAsset);
    const show = assetWithDevices !== undefined;

    return (
        <Sidebar
            title={'Asset Info'}
            titleClassName={'padding-left-10'}
            closed={!show}
            onClose={() => dispatch(resetAssetSidebar())}
            position={'right'}
            fly={true}
            width={500}
        >
            <div className={'height-100pct overflow-y-scroll'}>
                <AssetDetails asset={assetWithDevices} />
                {assetWithDevices && <ActionArea assetWithDevices={assetWithDevices} />}
            </div>
        </Sidebar>
    );
};

const ActionArea = ({ assetWithDevices }: { assetWithDevices: AssetWithDevices }) => {
    return (
        <div className={'display-flex flex-nowrap justify-content-center margin-top-50'}>
            <div className={'display-grid gap-20'}>
                <div className={'display-grid gap-10 grid-cols-3 margin-bottom-25'}>
                    <DeleteAsset asset={assetWithDevices.asset} />
                    {assetWithDevices.asset.status === AssetStatus.ACTIVE ? (
                        <ArchiveAsset asset={assetWithDevices.asset} />
                    ) : (
                        <ActivateAsset asset={assetWithDevices.asset} />
                    )}
                    <AssociateDevice asset={assetWithDevices.asset} />
                </div>
            </div>
        </div>
    );
};
